<div class="user-activity-div">
    <sh-page class="page-setting" theme={{theme_color}}>
<sh-table>
    <sh-table-row>
      <sh-table-cell columns="13">Number of users logged in today</sh-table-cell>
      <sh-table-cell columns="1">{{userStatistics?.usersLoggedInToday}}</sh-table-cell>
    </sh-table-row>
    <sh-table-row>
      <sh-table-cell columns="13">Number of users logged in this week</sh-table-cell>
      <sh-table-cell columns="1">{{userStatistics?.usersLoggedInLastWeek}}</sh-table-cell>
    </sh-table-row>
    <sh-table-row>
      <sh-table-cell columns="13">Number of users logged since the beginning</sh-table-cell>
      <sh-table-cell columns="1">{{userStatistics?.usersOfVALFromStart}}</sh-table-cell>
    </sh-table-row>
  </sh-table>
  </sh-page>
</div>